import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';

/**
 * Business Partner Cell Renderer Component
 *
 * Wrapper cell renderer for BusinessPartnerDisplayComponent.
 * Displays soldTo (pagador) and shipTo (receptor) information with icons.
 *
 * Copied from: src/app/modules/components/monitor/table-load-list/table-load-list.component.html (lines 148-150)
 *
 * Usage in ColDef:
 * ```typescript
 * {
 *   field: 'soldTo.name',
 *   headerName: 'Pagador/Receptor',
 *   cellRenderer: BusinessPartnerCellRendererComponent,
 *   width: 250
 * }
 * ```
 */
@Component({
  selector: 'app-business-partner-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    BusinessPartnerDisplayComponent,
  ],
  template: `
    <app-business-partner-display
      class="leading-tight"
      [soldTo]="soldTo"
      [shipTo]="shipTo"
      [customerType]="shipToType"
      [showIcons]="true">
    </app-business-partner-display>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessPartnerCellRendererComponent implements CellRenderer<any, any> {
  /**
   * Parameters from the grid containing the cell value and row data
   */
  @Input() params!: CellRendererParams<any, any>;

  /**
   * Order data
   */
  get order(): any {
    return this.params?.data;
  }

  /**
   * Sold to (pagador) partner
   */
  get soldTo(): any {
    return this.order?.soldTo;
  }

  /**
   * Ship to (receptor) partner
   */
  get shipTo(): any {
    return this.order?.shipTo;
  }

  /**
   * Ship to customer type
   */
  get shipToType(): any {
    return this.order?.shipToType;
  }
}
